import api from '../client'

export async function fetchDepartmentOptions(search = '', page = 1, pageSize = 20, companyIds = null, branchIds = null) {
  const params = { search, page, page_size: pageSize }
  if (companyIds && companyIds !== 'All') {
    params.company_ids = Array.isArray(companyIds) ? companyIds.join(',') : String(companyIds)
  }
  if (branchIds && branchIds !== 'All') {
    params.branch_ids = Array.isArray(branchIds) ? branchIds.join(',') : String(branchIds)
  }
  const { data } = await api.get('/options/departments', { params })
  const rawItems = Array.isArray(data) ? data : Array.isArray(data?.items) ? data.items : []
  const items = rawItems.map((item) => ({
    value: String(item.id),
    label: item.name || item.code || String(item.id),
  }))
  const hasMore = rawItems.length === pageSize
  return { items, hasMore }
}
